<div
  class="role-delete-impact-card rounded-xl p-4 sm:p-5 my-2 border text-white"
  style="background-color: #0c182b; border-color: #1b3152; color: #ffffff;"
>
  <!-- Header with Info Icon -->
  <div class="flex items-center gap-2.5 mb-4">
    <div
      class="impact-info-badge"
      style="background-color: #1b84ff; width: 22px; height: 22px; border-radius: 50%;"
    >
      <svg
        viewBox="0 0 16 16"
        fill="#ffffff"
        style="width: 14px; height: 14px; fill: #ffffff;"
      >
        <path
          d="M8 1.5a6.5 6.5 0 1 0 6.5 6.5A6.5 6.5 0 0 0 8 1.5zM8 4a.9.9 0 1 1-.9.9A.9.9 0 0 1 8 4zm1.1 7.2H6.9a.6.6 0 0 1 0-1.2h.6V7.4h-.6a.6.6 0 0 1 0-1.2h1.7a.6.6 0 0 1 .6.6v3.8h.6a.6.6 0 0 1 0 1.2z"
          fill="#ffffff"
        />
      </svg>
    </div>
    <span
      class="text-sm font-semibold tracking-wide"
      style="color: #ffffff; font-size: 14px; font-weight: 600;"
    >
      {{ title }}
    </span>
  </div>

  <!-- Items list -->
  <div class="flex flex-col gap-3.5 pl-1">
    <div *ngFor="let item of items" class="flex items-start gap-3">
      <!-- Icon -->
      <div
        class="impact-icon-wrapper"
        style="color: #94a3b8;"
      >
        <ng-container [ngSwitch]="item.icon">
          <!-- Users icon -->
          <svg
            *ngSwitchCase="'users'"
            class="impact-svg-fill"
            viewBox="0 0 20 20"
            fill="#94a3b8"
            style="width: 20px; height: 20px; fill: #94a3b8; color: #94a3b8;"
          >
            <path
              d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
              fill="#94a3b8"
            />
          </svg>

          <!-- Shield icon -->
          <svg
            *ngSwitchCase="'shield'"
            class="impact-svg-stroke"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#94a3b8"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="width: 20px; height: 20px; stroke: #94a3b8; color: #94a3b8;"
          >
            <path
              d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
              stroke="#94a3b8"
            />
          </svg>

          <!-- Document icon -->
          <svg
            *ngSwitchCase="'document'"
            class="impact-svg-stroke"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#94a3b8"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="width: 20px; height: 20px; stroke: #94a3b8; color: #94a3b8;"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              stroke="#94a3b8"
            />
            <polyline
              points="14 2 14 8 20 8"
              stroke="#94a3b8"
            />
            <line
              x1="16"
              y1="13"
              x2="8"
              y2="13"
              stroke="#94a3b8"
            />
            <line
              x1="16"
              y1="17"
              x2="8"
              y2="17"
              stroke="#94a3b8"
            />
            <line
              x1="10"
              y1="9"
              x2="8"
              y2="9"
              stroke="#94a3b8"
            />
          </svg>

          <!-- Generic / KeenIcon fallback -->
          <i
            *ngSwitchDefault
            [class]="item.icon + ' text-base'"
            style="color: #94a3b8;"
          ></i>
        </ng-container>
      </div>

      <!-- Content -->
      <div class="flex flex-col gap-0.5">
        <span class="impact-title">
          {{ item.title }}
        </span>
        <span class="impact-desc">
          {{ item.description }}
        </span>
      </div>
    </div>
  </div>
</div>
